import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router, RouterLink } from '@angular/router';
import { environment } from 'src/environments/environment.prod';
import { AppConstants } from 'src/app/app.constants';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { ProductService } from 'src/_lib/service/product.service';
import { NgIf, NgFor, NgSwitch, NgSwitchCase, NgClass, NgStyle } from '@angular/common';
import { CartService } from 'src/_lib/service/cart.service';
import { StarArrayPipe } from 'src/_lib/pipes/star-array.pipe';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { AffirmWidgetComponent } from 'src/app/templates/featured-product/component/affirm-widget/affirm-widget.component';
import { LoveItPopupComponent } from 'src/app/templates/featured-product/component/product-details/love-it-popup/love-it-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { TruncateHtmlPipe } from 'src/_lib/pipes/truncate-html.pipe';
import { removeBackslash } from 'src/_lib/pipes/removebackslash.pipe';
import { CustomCurrencyPipe } from 'src/_lib/pipes/customCurrency.pipe';
import { PaypalWidgetComponent } from 'src/app/templates/featured-product/component/paypal-widget/paypal-widget.component';
import { StripHtmlPipe } from 'src/_lib/pipes/stripHtml.pipe';
import { GtmService } from 'src/_lib/service/gtm.service';
import { CartVerifyPopupComponent } from 'src/app/templates/cart/component/cart-verify-popup/cart-verify-popup.component';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-recently-viewed',
  templateUrl: './recently-viewed.component.html',
  styleUrls: ['./recently-viewed.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, StarArrayPipe, NgSwitch, NgSwitchCase, AffirmWidgetComponent, NgClass, NgStyle, RouterLink, TruncateHtmlPipe, removeBackslash, CustomCurrencyPipe, PaypalWidgetComponent, StripHtmlPipe]
})
export class RecentlyViewedComponent implements OnInit {
  firstObj: number = this.appConstants.firstObj;
  cdnImagePath = environment.cdnImagePath;
  commonImagePath: string = environment.commonImagePath;
  recentlyViewedProducts: any[] = [];
  order_key: number = null;
  totalAverageOutOf5: number = null;
  rating: number = 0;
  reviewsCount: number = 0;
  currentIndex = 0;
  visibleItems = 6;
  addToCartButtons: { [product_variation_key: number]: boolean } = {};
  disableCheckoutButton: boolean = false;
  inventoryDisabled: boolean = false;
  paypalClientId: string = '';
  touchStartX = 0;
  touchEndX = 0;
  minSwipeDistance = 50;
  defaultSubtitle: boolean = false;
  hideSubtitle: boolean = false;
  contact: string = environment.contact_no;
  formatted_contact: string = this.contact.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  chTheme1 = environment.chTheme1;
  chTheme4 = environment.chTheme4;
  addToCartFlag: { [key: number]: boolean } = {};

  @Input() productKeys: number[] = [];
  @Output() recentlyViewedStatus: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private appConstants: AppConstants,
    private comm: CommunicationService,
    private productHttp: ProductService,
    private cartService: CartService,
    private dialog: MatDialog,
    private commonService: CommanpageService,
    private gtmService: GtmService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private browser: BrowserService
  ) { }

  ngOnInit(): void {
    this.paypalClientId = this.commonService.paypalClientIdDetails();
    this.inventoryDisabled = this.commonService.isInventoryDisabled();
    this.defaultSubtitle = this.commonService.isDefaultSubtitle();
    this.hideSubtitle = this.commonService.isSubtitleHidden();
    this.updateVisibleItems(this.browser.window?.innerWidth);
    this.comm.cartItemRemoved$.subscribe((flag) => {
      if (flag) {
        this.setInitialAddToCartButtons();
        this.syncCartButtonStates();
      }
    });
    if (this.productKeys?.length > 0) {
      this.loadRecentlyViewedProducts();
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updateVisibleItems(event.target.innerWidth);
  }

  updateVisibleItems(width: number) {
    if (width < 576) {
      this.visibleItems = 2;
    } else if (width < 992) {
      this.visibleItems = 3;
    } else {
      this.visibleItems = 6;
    }
  }

  loadRecentlyViewedProducts(): void {
    this.productHttp.getRecentlyViewedProducts(this.productKeys).subscribe({
      next: (response) => {
        if (response[this.firstObj]?.success && response[this.firstObj]?.data?.length > 0) {
          this.recentlyViewedProducts = response[this.firstObj]?.data || [];
          this.recentlyViewedProducts.map(product => {
            if(product?.add_to_cart == 'on' && product?.product_variations?.length == 1){
              if(product?.product_variations[0]?.add_to_cart == 'on'){
                this.addToCartFlag[product.product_key] = true
              }else{
                this.addToCartFlag[product.product_key] = false
              }
            }else if(product?.add_to_cart == 'off' && product?.product_variations?.length == 1){
              this.addToCartFlag[product.product_key] = false
            }else{
              this.addToCartFlag[product.product_key] = true
            }
          });
          this.recentlyViewedStatus.emit(this.recentlyViewedProducts?.length > 0);
          this.setInitialAddToCartButtons();
          this.syncCartButtonStates();
          for (let i = 0; i < this.recentlyViewedProducts?.length; i++) {
            const product = this.recentlyViewedProducts[i];
            let avgRating = 0;
            let reviewsCount = 0;
            if (product?.reviews && product.reviews?.length > 0) {
              reviewsCount = product.reviews?.length;
              const sum = product.reviews.reduce((acc: number, review: any) => {
                const scores = [
                  +review.appearance || 0,
                  +review.installation || 0,
                  +review.price_value || 0,
                  +review.quality || 0,
                ];
                const reviewAvg =
                  scores.reduce((a, b) => a + b, 0) / scores?.length;
                return acc + reviewAvg;
              }, 0);
              avgRating = sum / reviewsCount;
            }
            product.avgRating = avgRating;
            product.reviewsCount = reviewsCount;
          }
        } else {
          this.recentlyViewedProducts = [];
          this.recentlyViewedStatus.emit(false);
          console.error(
            'Custom Error: Unexpected Error while getting recently viewed products'
          );
        }
      },
      error: (error: Error) => {
        console.error(
          'Custom Error: Unexpected Error while fetching recently viewed products from api',
          error
        );
      },
    });
  }

  getProductSubtitle(product: any): string {
    if (this.hideSubtitle) {
      return '';
    }
    if (this.defaultSubtitle) {
      return product?.tagline || '';
    }
    if (product?.tagline) {
      return product.tagline;
    }
    const variationConfig =
      product?.product_variations?.[0]?.product_variation_configuration?.[0];
    const specLabel = this.extractSpecificationValues(
      variationConfig?.specification_label1?.trim() || ''
    );
    const specValue = this.extractSpecificationValues(
      variationConfig?.specification_value1?.trim() || ''
    );
    if (specLabel || specValue) {
      return `${specLabel} ${specValue}`.trim();
    }
    if (product?.short_description) {
      return product.short_description;
    }
    return '';
  }

  extractSpecificationValues(htmlString: string): string {
    if (!htmlString) return '';
    if (typeof document !== 'undefined') {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    const liElements = tempDiv.querySelectorAll('li');
    const values: string[] = [];
    liElements.forEach(li => {
      let text = li.textContent || '';
      text = this.fixEncoding(text);
      const parts = text.split(':');
      if (parts?.length > 1) {
        values.push(parts.slice(1).join(':').trim());
      }
    });
    return values.join(', ');
  }else return '';
  }

  fixEncoding(text: string): string {
    if (!text) return '';
    if (typeof document !== 'undefined') {
    const txt = document.createElement('textarea');
    txt.innerHTML = text;
    return txt.value
      .replace(/&Atilde;&#151;/g, '×')
      .replace(/Ã—/g, '×')
      .replace(/\s+/g, ' ')
      .trim();
    }else return '';
  }

  setInitialAddToCartButtons() {
    this.addToCartButtons = {};
    for (let product of this.recentlyViewedProducts) {
      const variationKey = product?.product_variations?.[0]?.product_variation_key;
      if (variationKey) {
        this.addToCartButtons[variationKey] = true;
      }
    }
  }

  syncCartButtonStates() {
    const orderItemsList = this.cartService.getOrderItemsList();
    if (orderItemsList) {
      for (let product of this.recentlyViewedProducts) {
        const variationKey = product?.product_variations?.[0]?.product_variation_key;
        if (orderItemsList[variationKey]) {
          this.addToCartButtons[variationKey] = false;
        }
      }
    }
  }

  getProductPromotion(product: any): {
    promotionDescription: string;
    promotionDiscount: number;
    promotionType: string;
  } | null {
    if (product?.promotions) {
      return {
        promotionDescription: product.promotions.one_line_description,
        promotionDiscount: +product.promotions.discount,
        promotionType: product.promotions.promotion_type,
      };
    }
    return null;
  }

  getProductFinalPrice(product: any): {
    originalPrice: number;
    finalPrice: number;
    msrpPrice?: number;
    showMsrp?: boolean;
  } {
    const variation = product?.product_variations?.[0];
    const price = +variation?.price || 0;
    const msrp = +variation?.msrp_price || 0;
    if (product?.promotions) {
      const discount = +product.promotions.discount || 0;
      const type = product.promotions.promotion_type;
      let finalPrice = price;
      if (type === 'percentage_discount') {
        finalPrice = price - (price * discount) / 100;
      }
      else if (type === 'discount_flat_rate') {
        finalPrice = price - discount;
      }
      return {
        originalPrice: price,
        finalPrice: finalPrice > 0 ? finalPrice : 0,
        msrpPrice: null,
        showMsrp: false
      };
    }
    return {
      originalPrice: price,
      finalPrice: price,
      msrpPrice: msrp,
      showMsrp: msrp > price
    };
  }

  addToCart(product: any) {
    this.order_key = +this.browser.localStorage?.getItem('orderId') || null;
    const variationKey = product?.product_variations?.[0]?.product_variation_key;
    const variation = product?.product_variations?.[0];
    if (!variationKey || !variation) return;
    const isNewProductFreight = variation?.is_freight_shipping == 1;
    const cartShippingType = this.cartService.getCartShippingType();
    if (cartShippingType !== null) {
      const cartIsFreight = cartShippingType === 'freight';
      if (cartIsFreight !== isNewProductFreight) {
        this.dialog.open(CartVerifyPopupComponent, {
          data: {
            messages: [cartIsFreight ? 'Your cart contains freight shipping items. Only freight shipping products can be added.' : 'Your cart contains standard shipping items. Only standard shipping products can be added.'],
            isFreight: cartIsFreight
          }
        });
        return;
      }
    }
    this.disableCheckoutButton = true;
    this.cartService.addToCart(
      {
        product_key: product?.product_key,
        product_variation_key: variationKey,
        sku: variation?.sku,
        customer_price: variation?.price,
        promotion_key: product?.promotions
          ? product?.promotions?.promotion_key
          : 0,
      },
      this.order_key,
      1,
      Number(variation?.price),
      product?.promotions ? product?.promotions?.promotion_key : null,
      false,
      '',
      false
    );
    this.gtmService.pushEvent('add_to_cart', {
      ecommerce: {
        currency: 'USD',
        value: Number(variation?.price),
        items: [
          {
            item_id: variationKey,
            item_name: product?.name,
            item_brand: product?.brand?.brand_name,
            item_category: product?.product_cat?.category?.name,
            price: Number(variation?.price),
            quantity: 1
          }
        ]
      }
    });
    this.comm.itemCount.next(null);
    this.disableCheckoutButton = false;
    this.addToCartButtons[variationKey] = false;
    this.cartService.setCartShippingType(isNewProductFreight);
  }

  productRedirection(product: any): void {
    const variation = product?.product_variations?.[0];
    const price = Number(variation?.price) || 0;
    this.gtmService.pushEvent('view_item', {
      ecommerce: {
        currency: 'USD',
        value: price,
        items: [
          {
            item_id: variation?.product_variation_key,
            item_name: product?.name,
            item_brand: product?.brand?.brand_name,
            item_category: product?.product_cat?.category?.name,
            value: price
          }
        ]
      }
    });
    const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
    const productKey = product?.product_key;
    const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
    updatedProducts.unshift(productKey);
    this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
    this.comm.showLoader();
    this.commonService.productRedirection(product.name, product?.product_key);
    setTimeout(() => {
      this.browser.window?.scrollTo(0, 0);
    }, 100);
  }

  productRedirectionWithColor(product: any, color: any): void {
    const variation = product?.product_variations?.[0];
    const price = Number(variation?.price) || 0;
    this.gtmService.pushEvent('view_item', {
      ecommerce: {
        currency: 'USD',
        value: price,
        items: [
          {
            item_id: variation?.product_variation_key,
            item_name: product?.name,
            item_brand: product?.brand?.brand_name,
            item_category: product?.product_cat?.category?.name,
            value: price
          }
        ]
      }
    });
    const existingProducts = JSON.parse(this.browser.localStorage?.getItem('recentlyViewedProducts') || '[]');
    const productKey = product?.product_key;
    const updatedProducts = existingProducts.filter((key: any) => key !== productKey);
    updatedProducts.unshift(productKey);
    this.browser.localStorage?.setItem('recentlyViewedProducts', JSON.stringify(updatedProducts));
    this.comm.showLoader();
    this.commonService.productRedirection(product.name, product?.product_key, color.color_key);
    setTimeout(() => {
      this.browser.window?.scrollTo(0, 0);
    }, 100);
  }

  openLoveItPopup(product: any): void {
    this.browser.localStorage.setItem('selectedproductkey', String(product.product_key));
    this.browser.localStorage.setItem('selectedProductName', product.name);
    this.dialog.open(LoveItPopupComponent,{data: { product_name: product.name, prod_description: product.short_description, prod_image: product.product_photo.large_image, product_key:product.product_key }});
  }

  goToTop() {
    this.browser.window?.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  nextSlide(): void {
    const maxIndex = this.recentlyViewedProducts?.length - this.visibleItems;
    if (this.currentIndex < maxIndex) {
      this.currentIndex++;
    }
  }

  prevSlide(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  onProductImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = `${this.commonImagePath}image_not_found.webp`;
  }

  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].screenX;
    this.touchEndX = this.touchStartX;
  }

  onTouchEnd(event: TouchEvent) {
    this.touchEndX = event.changedTouches[0].screenX;
    const distance = this.touchStartX - this.touchEndX;
    if (Math.abs(distance) > this.minSwipeDistance) {
      distance > 0 ? this.nextSlide() : this.prevSlide();
    }
  }

  onContactClick(product: any) {
    this.router.navigate(['/contact-us'], {
      queryParams: { subject: `${product.name}` },
    });
  }

  getInventoryData(item: any): {
    qty: number;
    isInStock: boolean;
    warehouse: 'karls' | 'partner';
    karlsQty: number;
  } {
    const fulfillmentInventory = item?.product_variations?.[0]?.product_fulfillment_inventory || [];
    const karlsQty = fulfillmentInventory
      .filter(
        (inv: any) =>
          inv?.branch_id === 'r&r' ||
          inv?.product_fulfillment_location?.distributors === 'karlkustoms'
      )
      .reduce((sum: number, inv: any) => sum + (Number(inv.qty) || 0), 0);
    const totalQty = fulfillmentInventory.reduce(
      (sum: number, inv: any) => sum + (Number(inv.qty) || 0),
      0
    );
    const warehouse: 'karls' | 'partner' = karlsQty > 0 ? 'karls' : 'partner';
    return {
      qty: totalQty,
      isInStock: totalQty > 0,
      warehouse,
      karlsQty
    };
  }

  getInventoryMessages(
    qty: number,
    isInStock: boolean,
    warehouse: 'karls' | 'partner' = 'karls',
    karlsQty: number = 0
  ) {
    const now = new Date();
    const cstTime = new Date(
      now.toLocaleString('en-US', { timeZone: 'America/Chicago' })
    );
    const day = cstTime.getDay();
    const hours = cstTime.getHours();
    const isSaturday = day === 6;
    const isSunday = day === 0;
    const isWeekday = day >= 1 && day <= 5;
    const before3PM = hours < 15;
    const beforeNoon = hours < 12;
    const after8AM = hours >= 8;
    let availabilityMsg = '';
    let urgencyMsg = '';
    let pickupMsg = '';
    if (!isInStock || Number(qty) <= 0) {
      return {
        availabilityMsg: 'Ships from Supplier in 2 to 4 Weeks (Pending Availability)',
        urgencyMsg: '',
        pickupMsg: 'Local pickup not available',
        showBackorder: true,
      };
    }
    if (qty <= 5) {
      urgencyMsg = `Only ${qty} left, order soon`;
    }
    if (karlsQty <= 0) {
      pickupMsg = 'Local pickup not available';
    }
    if (warehouse === 'karls') {
      const isAfterSatNoon = isSaturday && !beforeNoon;
      const isBeforeMon8AM = day === 1 && !after8AM;
      if (isAfterSatNoon || isSunday) {
        availabilityMsg = isSunday ? 'In Stock, expected to ship tomorrow' : 'In Stock ships Monday';
        if (karlsQty > 0) {
          pickupMsg = 'Local pick-up available Monday morning from 8AM to 12PM CST';
        } else {
          pickupMsg = 'Local pickup not available';
        }
        return {
          availabilityMsg,
          urgencyMsg,
          pickupMsg,
          showBackorder: false,
        };
      }
      if (isBeforeMon8AM) {
        availabilityMsg = 'In Stock, expected to ship today';
        if (karlsQty > 0) {
          pickupMsg = 'Local pick-up available today from 8AM to 5PM CST';
        } else {
          pickupMsg = 'Local pickup not available';
        }
        return {
          availabilityMsg,
          urgencyMsg,
          pickupMsg,
          showBackorder: false,
        };
      }
      if (isWeekday) {
        availabilityMsg = before3PM ? 'In Stock, expected to ship today' : 'In Stock, expected to ship tomorrow';
        if (karlsQty > 0) {
          pickupMsg = `${karlsQty} available for local pickup at Karl Kustoms in Des Moines, IA from 8AM to 5PM CST`;
        }
      }
      if (isSaturday) {
        availabilityMsg = 'In Stock ships Monday';
        if (!after8AM) {
          pickupMsg = karlsQty > 0 ? 'Local pick-up available Monday morning from 8AM to 12PM CST' : 'Local pickup not available';
        } else if (beforeNoon) {
          pickupMsg = karlsQty > 0 ? `${karlsQty} available for local pickup at Karl Kustoms in Des Moines, IA from 8AM to 12PM CST` : 'Local pickup not available';
        }
      }
    }
    if (warehouse === 'partner') {
      if (isWeekday) {
        availabilityMsg = before3PM ? 'In Stock, expected to ship today' : 'In Stock, expected to ship tomorrow';
      }
      if (isSaturday) {
        availabilityMsg = 'In Stock ships today or Monday';
      }
      if (isSunday) {
        availabilityMsg = 'In Stock, expected to ship tomorrow';
      }
    }
    return {
      availabilityMsg,
      urgencyMsg,
      pickupMsg,
      showBackorder: false,
    };
  }

  getPickupMsgHtml(product: any): SafeHtml {
    const inv = this.getInventoryData(product);
    const msg = this.getInventoryMessages(inv.qty, inv.isInStock, inv.warehouse, inv.karlsQty)?.pickupMsg || '';
    const html = msg
      .replace(/^(\d+ available for local pickup)/, '<span style=" font-family:var(--font-secondary-bold)">$1</span>')
      .replace('at Karl Kustoms', '<span style="font-family:var(--font-secondary-bold)"><strong><u>at Karl Kustoms</u></strong></span>');
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}